"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customPropTypes = require("@paprika/helpers/lib/customPropTypes");

var propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]).isRequired,

  /** Sets id for label */
  idForLabel: _propTypes["default"].string,
  refLabel: (0, _customPropTypes.RefOf)(),

  /** Used for aria-describedby on the FormElement */
  ariaDescribedBy: _propTypes["default"].string
};
var defaultProps = {
  idForLabel: null,
  ariaDescribedBy: null,
  refLabel: null
};

function Content(props) {
  var children = props.children,
      idForLabel = props.idForLabel,
      refLabel = props.refLabel,
      ariaDescribedBy = props.ariaDescribedBy,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "idForLabel", "refLabel", "ariaDescribedBy"]);

  if (!children) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-pka-anchor": "form-element.content"
  }, moreProps), typeof children === "function" ? children({
    idForLabel: idForLabel,
    refLabel: refLabel,
    ariaDescribedBy: ariaDescribedBy
  }) : children);
}

Content.displayName = "FormElement.Content";
Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
var _default = Content;
exports["default"] = _default;
//# sourceMappingURL=Content.js.map